import { Injectable } from "@angular/core";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/api";

@Injectable({
    providedIn: "root"
})
export class DynamicDialogService {

    private dialogRef: DynamicDialogRef;
    private dialogConfig: DynamicDialogConfig = null;

    constructor(private dialogService: DialogService) { }

    openDialog(component: any, config: DynamicDialogConfig): DynamicDialogRef {
        this.dialogConfig = config;
        this.dialogRef = this.dialogService.open(component, config);

        return this.dialogRef;
    }

    getConfigData(): any | null {
        return this.dialogConfig ? this.dialogConfig.data : null;
    }

    closeDialog(data?: any): void {
        if (this.dialogRef) {
            this.dialogRef.close(data);
            this.dialogConfig = null;
        }
    }
}
